module.exports = __webpack_public_path__ + "img/user_avatar.bfa0139d.png";